var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 24 24","fill":"currentColor","aria-hidden":"true"}},[_c('path',{attrs:{"d":"M12 7C9.5 4 5 4 3 8C1 12 5 15.5 12 20C19 15.5 23 12 21 8C19 4 14.5 4 12 7Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }